import React from 'react';
import asyncRoute from '../../../helpers/hoc/asyncRoute';
import { constants } from '../../../constants/configuration';
import FallbackImg from '../../../assets/images/placeHolder/Searching.svg';
import "./NonExistentSubdomainFallback.scss"

const Fallback = asyncRoute(() => import('../../Fallback'));

const resourceContent = constants.fallbackUI.NonExistentSubdomainFallback;

const NonExistentSubdomainFallback = ({ handleGoHome, resources }) => {
  return (
    <div className="subdomain-fallback">
      <Fallback
        resources={resources ? resources : resourceContent}
        FallbackImg={FallbackImg}
        handleCTA={handleGoHome}
      />
    </div>
  );
};

export default NonExistentSubdomainFallback;
